import { z } from "zod";
import { highMobilityConnectionPlanSchema } from "../_shared";

export const connectVehiclesToProviderPayloadSchema = z.object({
  vehicleUuids: z.array(z.uuid()),
  connectionPlan: highMobilityConnectionPlanSchema,
  requestedConnectionBy: z.string().optional(),
});

export type ConnectVehiclesToProviderPayload = z.infer<
  typeof connectVehiclesToProviderPayloadSchema
>;
